// EXTERNAL
import React from 'react'

// INTERNAL
import CarBpmDeclarationView from '../views/bpm-declaration/car-bpm-declaration-view'

const CarBpmDeclarationViewContainer = () => <CarBpmDeclarationView />

export default CarBpmDeclarationViewContainer
